var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnableToPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 37,
    viewBox: "0 0 43 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2319_21891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.97616 11.1684C7.1994 8.90757 8.99407 7.12233 11.256 6.91099L34.0089 4.78521C34.2324 4.76433 34.4571 4.75933 34.6814 4.77027L36.3798 4.85312C36.5453 4.8612 36.7092 4.89055 36.8673 4.94046C37.6712 5.19424 38.2177 5.93991 38.2177 6.78289V22.868C38.2177 25.5883 35.935 27.7514 33.2187 27.6054L31.4799 27.5118V31.3888L29.7222 30.9983L27.1834 27.2807L8.32417 26.3377C7.39873 26.2914 6.56158 25.774 6.10633 24.967C5.83343 24.4832 5.7163 23.9271 5.77088 23.3744L6.97616 11.1684Z",
    fill: "#EBEEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4907 27.3121L31.2799 27.3008V27.5118V31.1395L29.8428 30.8202L27.3485 27.1679L27.2925 27.0859L27.1933 27.081L8.33416 26.138C7.47723 26.0951 6.70207 25.616 6.28052 24.8687C6.02783 24.4208 5.91937 23.9058 5.96991 23.394L7.17519 11.1881C7.38902 9.02253 9.10803 7.31255 11.2747 7.11013L34.0275 4.98434C34.2416 4.96434 34.4568 4.95956 34.6716 4.97004L36.37 5.05288C36.5185 5.06013 36.6654 5.08644 36.8071 5.13118C37.5277 5.35869 38.0177 6.02717 38.0177 6.78289V22.868C38.0177 25.4736 35.8313 27.5456 33.2295 27.4056L31.4907 27.3121Z",
    stroke: "#BB7065",
    strokeOpacity: 0.4,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58252 11.2681C5.58252 8.78151 7.50239 6.71686 9.98238 6.53639L31.3511 4.98143C34.0996 4.78142 36.4396 6.95734 36.4396 9.71309V22.4496C36.4396 25.1699 34.157 27.3331 31.4406 27.187L29.7018 27.0935V30.9704L25.4053 26.8624L10.0719 26.0377C7.55441 25.9022 5.58252 23.8214 5.58252 21.3003V11.2681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7126 26.8937L29.5018 26.8824V27.0935V30.5025L25.5435 26.7178L25.49 26.6666L25.416 26.6626L10.0826 25.8379C7.67128 25.7082 5.78252 23.7152 5.78252 21.3003V11.2681C5.78252 8.88634 7.62146 6.90872 9.9969 6.73587L31.3656 5.1809C33.9982 4.98933 36.2396 7.07351 36.2396 9.71309V22.4496C36.2396 25.0552 34.0532 27.1272 31.4514 26.9873L29.7126 26.8937Z",
    stroke: "#BB7065",
    strokeOpacity: 0.4,
    strokeWidth: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2226 19.1279L17.0374 19.2782C16.8134 19.2782 16.6301 19.0809 16.6301 18.8377L16.6287 10.8509C16.6287 10.6078 16.8112 10.4105 17.036 10.4105L19.2226 10.6287C19.4473 10.6287 19.6299 10.826 19.6299 11.0691V18.6874C19.6299 18.9306 19.4465 19.1279 19.2226 19.1279Z",
    fill: "#BB7065"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7758 18.5795C27.7155 18.5906 24.8398 18.7618 24.8398 18.7618L25.2338 19.9321C25.5056 20.7404 25.3296 21.9746 24.5753 22.4134C24.3297 22.5562 23.9865 22.628 23.7099 22.5522C23.5512 22.5087 23.4118 22.3943 23.3287 22.2411C23.2331 22.0649 23.2429 21.8591 23.2089 21.6637C23.1226 21.1681 22.9075 20.6968 22.5744 20.3431C21.9936 19.7264 20.1895 18.7618 20.1895 18.7618V11.2152L26.424 11.4308C27.2653 11.4303 27.8166 12.4531 27.4017 13.2521C27.8963 13.597 28.0654 14.3234 27.7758 14.8812C28.2704 15.2261 28.4395 15.9525 28.1498 16.5103C28.8948 17.1383 28.7729 18.3959 27.7758 18.5795Z",
    fill: "#BB7065"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2319_21891",
    x: 0.363925,
    y: 0.494889,
    width: 42.1236,
    height: 36.1125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.474418,
    dy: 0.474418
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.37209
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2319_21891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2319_21891",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnableToPay);
export default __webpack_public_path__ + "static/media/unable_to_pay.513109f632a40b3b5918125b2bc1907b.svg";
export { ForwardRef as ReactComponent };